import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  request: `${NAMESPACE}_ROUTEMONITOR_REQUEST`,
  paginate: `${NAMESPACE}_ROUTEMONITOR_PAGINATE`,
  paginateSuccess: `${NAMESPACE}_ROUTEMONITOR_PAGINATE_SUCCESS`,
  requestSuccess: `${NAMESPACE}_ROUTEMONITOR_REQUEST_SUCCESS`,
  togglePendingOrderRow: `${NAMESPACE}_ROUTEMONITOR_TOGGLE_PENDING_ORDER_ROW`,
  openRoutePanel: `${NAMESPACE}_ROUTEMONITOR_OPEN_ROUTE_PANEL`,
  updateRoutePanelTitle: `${NAMESPACE}_ROUTEMONITOR_UPDATE_ROUTE_PANEL_TITLE`,
  closeRoutePanel: `${NAMESPACE}_ROUTEMONITOR_CLOSE_ROUTE_PANEL`,
  clearState: `${NAMESPACE}_ROUTEMONITOR_CLEAR_STATE`,
  addRouteToMap: `${NAMESPACE}_ROUTEMONITOR_ADD_ROUTE_TO_MAP`,
  selectRouteOnMap: `${NAMESPACE}_ROUTEMONITOR_SELECT_ROUTE_ON_MAP`,
  removeFocusedRouteOnMap: `${NAMESPACE}_ROUTEMONITOR_CLEAR_SELECTED_ROUTES_ON_MAP`,
  removeRouteFromMap: `${NAMESPACE}_ROUTEMONITOR_REMOVE_ROUTE_FROM_MAP`,
  removeAllRoutesFromMap: `${NAMESPACE}_ROUTEMONITOR_REMOVE_ALL_ROUTES_FROM_MAP`,
  updateRoutesOnMap: `${NAMESPACE}_ROUTEMONITOR_UPDATE_ROUTES_ON_MAP`,
  toggleMapState: `${NAMESPACE}_ROUTEMONITOR_TOGGLE_MAP_STATE`,
  updateEquipmentFilters: `${NAMESPACE}_ROUTEMONITOR_UPDATE_EQUIPMENT_FILTERS`,
  resetEquipmentFilters: `${NAMESPACE}_ROUTEMONITOR_RESET_EQUIPMENT_FILTERS`
};

export const actionCreators = {
  request: (payload) => ({ type: actions.request, payload }),
  paginate: (payload) => ({ type: actions.paginate, payload }),
  paginateSuccess: (payload) => ({ type: actions.paginateSuccess, payload }),
  requestSuccess: (payload) => ({ type: actions.requestSuccess, payload }),
  togglePendingOrderRow: (payload) => ({ type: actions.togglePendingOrderRow, payload }),
  openRoutePanel: (payload) => ({ type: actions.openRoutePanel, payload }),
  closeRoutePanel: (payload) => ({ type: actions.closeRoutePanel, payload }),
  updateRoutePanelTitle: () => ({ type: actions.updateRoutePanelTitle }),
  clearState: () => ({ type: actions.clearState }),

  addRouteToMap: (payload) => ({ type: actions.addRouteToMap, payload }),
  removeFocusedRouteOnMap: () => ({ type: actions.removeFocusedRouteOnMap }),
  selectRouteOnMap: (payload) => ({ type: actions.selectRouteOnMap, payload }),
  updateRoutesOnMap: (payload) => ({ type: actions.updateRoutesOnMap, payload }),
  removeRouteFromMap: (payload) => ({ type: actions.removeRouteFromMap, payload }),
  removeAllRoutesFromMap: () => ({ type: actions.removeAllRoutesFromMap }),
  toggleMapState: () => ({ type: actions.toggleMapState }),

  updateEquipmentFilters: (payload) => ({ type: actions.updateEquipmentFilters, payload }),
  resetEquipmentFilters: () => ({ type: actions.resetEquipmentFilters })
};

export default {
  actions,
  actionCreators
};
